import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "address", "preview", "reset"]

  connect() { if (this.hasFieldTarget) this.update() }

  pick(event) {
    this.fieldTarget.value = event.detail.emoji
    this.changed()
  }

  reset() {
    this.fieldTarget.value = ""
    this.changed()
  }

  changed() {
    this.update()
    this.fieldTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  update() {
    const emoji = this.fieldTarget.value
    this.resetTarget.hidden = !emoji
    this.previewTarget.replaceChildren()
    if (emoji) { this.previewTarget.textContent = emoji; return }
    try {
      const value = this.addressTarget.value.trim()
      if (!value) throw new Error("No website yet")
      const url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`)
      if (!['http:', 'https:'].includes(url.protocol) || !url.hostname) throw new Error("Not a website")
      const image = document.createElement("img")
      image.src = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(url.hostname)}&sz=32`
      image.alt = ""
      image.referrerPolicy = "no-referrer"
      image.addEventListener("error", () => { if (this.previewTarget.contains(image)) this.fallback(this.previewTarget) })
      this.previewTarget.appendChild(image)
    } catch { this.fallback(this.previewTarget) }
  }

  imageError(event) { this.fallback(event.currentTarget.parentElement) }

  fallback(element) {
    const icon = document.createElement("i")
    icon.className = "bi bi-globe2"
    element.replaceChildren(icon)
  }
}
